import React from "react";

const MastiSkeleton = ({ rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="animate-pulse border-b border-gray-100">
          {/* Sl No */}
          <td className="px-4 py-4">
            <div className="mx-auto h-4 w-8 rounded bg-gray-100" />
          </td>
          {/* Name + Avatar */}
          <td className="px-4 py-4">
            <div className="flex items-center justify-center gap-3">
              <div className="h-9 w-9 shrink-0 rounded-full bg-gray-100" />
              <div className="space-y-1.5 text-left">
                <div className="h-3.5 w-28 rounded bg-gray-100" />
                <div className="h-3 w-20 rounded bg-gray-100" />
              </div>
            </div>
          </td>
          {/* Language */}
          <td className="px-4 py-4">
            <div className="mx-auto h-4 w-16 rounded bg-gray-100" />
          </td>
          {/* Type */}
          <td className="px-4 py-4">
            <div className="mx-auto h-6 w-14 rounded-full bg-gray-100" />
          </td>
          {/* Status / Action */}
          <td className="px-4 py-4">
            <div className="mx-auto h-6 w-20 rounded-full bg-gray-100" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default MastiSkeleton;
